<template>

  <div class="user">
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <!--添加门店-->
      <div class="common-form">名片基础设置</div>

      <el-form-item label="是否开启名片" prop="is_open_card">
        <el-switch v-model="form.is_open_card"></el-switch>
      </el-form-item>

      <el-form-item label="是否开启审核" prop="is_open_audit">
        <el-switch v-model="form.is_open_audit"></el-switch>
        <div>开启后，用户第一次上传名片或者修改名片后，都需要后台审核</div>
      </el-form-item>

      <el-form-item label="名片默认名片">
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUpload1">选择图片</el-button>
          <div v-if="form.moren_logo!=''" class="img">
            <img :src="form.moren_logo" width="100" height="100" />
          </div>
        </el-row>
      </el-form-item>

      <!-- <el-form-item label="是否开启组织架构" prop="is_open_architecture">
        <el-switch v-model="form.is_open_architecture"></el-switch>
      </el-form-item>

      <el-form-item label="人脉圈组织架构封面" v-if="form.is_open_architecture">
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUpload">选择图片</el-button>
          <div v-if="form.architecture!=''" class="img">
            <img :src="form.architecture" width="100" height="100" />
          </div>
        </el-row>
      </el-form-item>

      <el-form-item label="组织架构" v-if="form.is_open_architecture">
        <div class="edit_container">
          <Uediter :text="form.architecture_introduce" :config="ueditor.config" ref="ue" @contentChange="contentChangeFunc"></Uediter>
        </div>
      </el-form-item> -->

      <!-- <el-form-item label="人脉圈轮播图：" prop="image">
        <div class="draggable-list"  >
          <draggable class="wrapper" v-model="form.image">
            <span>
              <div class="item" v-for="(item,index) in form.image" :key="item">
                <img v-img-url="item" />
                <a href="javascript:void(0);" class="delete-btn" @click="deleteImg(index)"><i class="el-icon-close"></i></a>
              </div>
            </span>
          </draggable>
          <div class="item img-select" @click="openProductUpload"><i class="el-icon-plus"></i></div>
        </div>
      </el-form-item> -->
    </el-form>
    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">保存</el-button>
    </div>
    <!--商品图片组件-->
    <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload>
    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload>

    <Upload v-if="isupload1" :isupload="isupload1" :type="type" @returnImgs="returnImgsFunc1">上传图片</Upload>
  </div>
</template>
<script>
import Uediter from '@/components/UE.vue';
import CardApi from '@/api/card.js';
import { formatModel } from '@/utils/base.js';
import draggable from 'vuedraggable';
import Upload from '@/components/file/Upload';
export default {
   components: {
    Uediter,
    Upload,
    draggable
  },
  data() {
    return {
      ueditor: {
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      form: {
        is_open_card: false,
        is_open_audit:false,
        is_open_architecture:false,
        image:[],
        architecture_introduce:'',
        architecture:'',
        moren_logo:"",
        moren_logo_id:0
      },
      setting: [],
      loading: false,
      isProductUpload:false,
      isupload:false,
      isupload1:false,
    };
  },
  created() {
    /*获取列表*/
    this.getSetting();
  },
  methods: {

     /*获取富文本内容*/
    contentChangeFunc(e){
      this.form.architecture_introduce=e;
    },
    /*获取设置*/
    getSetting() {
      let self = this;
      let Params = {};
      CardApi.getSetting(Params, true)
        .then(data => {
          self.loading = false;
          self.form = formatModel(self.form, data.data.vars.values);
        })
        .catch(error => {});
    },
    /*点击保存*/
    onSubmit() {
      let self = this;
      let params = self.form;
      self.loading = true;
      CardApi.saveSetting(params, true)
        .then(data => {
          self.loading = false;
          if (data.code == 1) {
            self.$message({
              message: '恭喜你，保存成功',
              type: 'success'
            });
            self.getSetting();
          } else {
            self.loading = false;
          }
        })
        .catch(error => {
          self.loading = false;
        });
    },
      /*打开上传图片*/
    openProductUpload: function() {
      this.isProductUpload = true;
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      let self = this;
      if (e != null) {
        e.forEach(element => {
          console.log(element)
          self.form.image.push(element.file_path);
        });
      }
      self.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index) {
      let self = this;
      self.form.image.splice(index, 1);
      console.log(self.form.image);
    },

    /*上传*/
      openUpload(e) {
        this.type = e;
        this.isupload = true;
      },

      /*获取图片*/
      returnImgsFunc(e) {
        if (e != null && e.length > 0) {
          this.form.architecture = e[0].file_path;
        }
        this.isupload = false;
      },

      openUpload1(){
        this.isupload1 = true;
      },
        /*获取图片*/
        returnImgsFunc1(e) {
        if (e != null && e.length > 0) {
          this.form.moren_logo = e[0].file_path;
          this.form.moren_logo_id = e[0].file_id;
        }
        this.isupload1 = false;
      },

  }
};
</script>

<style>
.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/card/setting/getSetting.vue